;(function (window, APP, Backbone, Marionette, $, _) {
	'use strict';

	const Router = APP.module('Router');
	
	Router.LoginForm = Marionette.AppRouter.extend({
		permissions: {
			'index': {
				'type': 2,
				'redirect_to': '#'
			},
			'forgotPassword':    {
				'type': 2,
				'redirect_to': '#'
			},
			'passwordRecovery':  {
				'type': 2,
				'redirect_to': '#'
			},
			'SSOInitiate':  {
				'type': 2,
				'redirect_to': '#'
			},
			'SSOLoginCallbackCtrl':  {
				'type': 2,
				'redirect_to': '#'
			},
			'SSOLoginRegisterCtrl':  {
				'type': 2,
				'redirect_to': '#'
			}
		},
		appRoutes: {
			'(/)': 'index',
			'login': 'index',
			'initiate': 'SSOInitiate',
			'login-callback/:code': 'SSOLoginCallbackCtrl',
			'id_token=:token' : 'index',
			// 'login-register/:code': 'SSOLoginRegisterCtrl',
			'forgot-password': 'forgotPassword',
			'password_recovery?*queryString': 'passwordRecovery',
			'unsubscribe?*queryString': 'unsubscribe',
			'recovery-token-confirm': 'sendRecoveryTokenConfirmation'
		}
	});

}(window, APP, Backbone, Marionette, $, _));